module.exports = __webpack_public_path__ + "img/bg.71bd5bfe.jpeg";